import { styled } from '@kufox/mui/emotion';
import Link from '../components/Link';

const Nav = styled.div`
  padding: 0 24px;
  transition: all 0.3s ease-in-out;
  @media screen and (max-width: 768px) {
    padding: 0 12px;
  }
`;
const Navbar = styled.div`
  width: 100%;
  height: 80px;
  margin: 0 auto;
  display: flex;
  @media screen and (max-width: 768px) {
    height: 60px;
  }
  position: relative;
  flex: auto;
  transition: all 0.3s;
`;
const Links = styled.div`
  display: flex;
  align-items: center;
`;
const NavUserDom = styled.div`
  display: flex;
  align-items: center;
`;
const LogoLink = styled(Link)`
  display: flex;
  align-items: center;
  min-width: 122px;
  & div {
    display: flex;
    align-items: center;
  }
  & img {
    margin-right: 0 !important;
  }
  &:hover {
    opacity: 0.6;
  }
`;
const MenuBox = styled.div`
  width: 24px;
  margin-left: 8px;
  height: 100%;
  align-items: center;
  display: flex;
`;
const NavLinks = styled.div`
  height: 100%;
`;

export { Nav, Navbar, Links, NavUserDom, LogoLink, MenuBox, NavLinks };
